module.exports = __webpack_public_path__ + "img/logo-bca_qris2-active.c3c11f2b.svg";